<template>
  <el-dialog
    :title="$t('text.crop_image')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    width="1000px"
  >
    <div class="cropper-content">
      <div class="cropper-box">
        <div class="area-title">{{ $t('text.operation_area') }}</div>
        <div class="cropper">
          <vueCropper
            v-if="dialogVisible"
            ref="cropper"
            :img="image"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
            @realTime="realTime"
          ></vueCropper>
        </div>
        <div class="footer-btn mt-10">
          <div class="scope-btn">
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-zoom-in"
              @click="changeScale(1)"
              >{{ $t('text.enlarge') }}</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-zoom-out"
              @click="changeScale(-1)"
              >{{ $t('text.narrow') }}</el-button
            >
            <el-button size="mini" type="primary" plain @click="rotateLeft"
              >↺ {{ $t('text.left_rotation') }}</el-button
            >
            <el-button size="mini" type="primary" plain @click="rotateRight"
              >↻ {{ $t('text.right_rotation') }}</el-button
            >
          </div>
        </div>
      </div>
      <el-divider
        :direction="$root.screenWidth > 550 ? 'vertical' : 'horizontal'"
      ></el-divider>
      <div class="show-preview">
        <div class="area-title">{{ $t('text.preview_area') }}</div>
        <div :style="previews.div" class="preview">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" class="save-btn min-w-80" @click="finish()">{{
        $t('text.save')
      }}</el-button>
      <el-button @click="closeDialog()" class="cancel-btn">{{
        $t('text.cancel')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      option: {
        outputSize: 1, // Crop the quality of the resulting picture (0.1 - 1)
        outputType: 'png', // Crop the format of the generated picture（jpeg || png || webp）
        info: true, // Picture size information
        canScale: true, // Does the picture allow scrolling
        autoCrop: true, // Generate screenshot box by default
        autoCropWidth: 230, // Default generated screenshot box width
        autoCropHeight: 150, // Default height of generated screenshot box
        fixed: false, // Whether to enable the fixed ratio of the width and height of the screenshot box
        fixedNumber: [1.53, 1], // Width height ratio of screenshot box
        full: true, // false, Cut the picture according to the original proportion without distortion
        canMove: true, // Can the uploaded picture be moved
        canMoveBox: true, // Can the screenshot box be dragged
        original: false, // The uploaded image is rendered to the original scale
        centerBox: false, // Is the screenshot box limited to the picture
        height: true, // Whether to output equal scale pictures according to the DPR of the device
        infoTrue: true, // true, To show the width and height of the real output picture; false, Show the width and height of the screenshot box
        maxImgSize: 100000, // Limit the maximum width and height of the picture
        enlarge: 1, // The picture is output according to the scale multiple of the screenshot box
        mode: '100%' // Picture default rendering method
      },
      previews: {}
    }
  },
  props: {
    image: {
      type: String,
      required: true
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs.cropper.clearCrop()
      this.dialogVisible = false
    },
    // Image zoom
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // Rotate left
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    // Rotate right
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    // Real time preview function
    realTime(data) {
      this.previews = data
    },
    finish() {
      this.$refs.cropper.getCropData(data => {
        this.$emit('completeCrop', this.base64ImgtoFile(data))
        this.closeDialog()
      })
    },
    base64ImgtoFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  .cropper-box {
    width: 49%;
    .cropper {
      width: auto;
      height: 300px;
    }
  }

  .show-preview {
    width: 49%;
    .preview {
      overflow: hidden;
      border: 1px solid #67c23a;
      background: #cccccc;
    }
  }
  .el-divider--vertical::v-deep {
    height: auto;
  }
  .area-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #999;
    text-align: center;
  }
}
.scope-btn {
  .el-button {
    outline: 0;
    margin-bottom: 10px;
  }
}
@media (max-width: 550px) {
  .cropper-content {
    display: block;
    .cropper-box,
    .show-preview {
      width: 100%;
    }
  }
}
</style>
